/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";

export const protobufPackage = "microhard_util";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface MicrohardLanSettingsPb {
  utime: number;
  mhIp: string;
  mhNetmask: string;
  mhGateway: string;
  computerIp: string;
  computerNetmask: string;
}

function createBaseMicrohardLanSettingsPb(): MicrohardLanSettingsPb {
  return { utime: 0, mhIp: "", mhNetmask: "", mhGateway: "", computerIp: "", computerNetmask: "" };
}

export const MicrohardLanSettingsPb = {
  encode(message: MicrohardLanSettingsPb, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).sint64(message.utime);
    }
    if (message.mhIp !== "") {
      writer.uint32(18).string(message.mhIp);
    }
    if (message.mhNetmask !== "") {
      writer.uint32(26).string(message.mhNetmask);
    }
    if (message.mhGateway !== "") {
      writer.uint32(34).string(message.mhGateway);
    }
    if (message.computerIp !== "") {
      writer.uint32(42).string(message.computerIp);
    }
    if (message.computerNetmask !== "") {
      writer.uint32(50).string(message.computerNetmask);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MicrohardLanSettingsPb {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMicrohardLanSettingsPb();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.sint64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.mhIp = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.mhNetmask = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.mhGateway = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.computerIp = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.computerNetmask = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MicrohardLanSettingsPb {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      mhIp: isSet(object.mhIp) ? globalThis.String(object.mhIp) : "",
      mhNetmask: isSet(object.mhNetmask) ? globalThis.String(object.mhNetmask) : "",
      mhGateway: isSet(object.mhGateway) ? globalThis.String(object.mhGateway) : "",
      computerIp: isSet(object.computerIp) ? globalThis.String(object.computerIp) : "",
      computerNetmask: isSet(object.computerNetmask) ? globalThis.String(object.computerNetmask) : "",
    };
  },

  toJSON(message: MicrohardLanSettingsPb): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.mhIp !== "") {
      obj.mhIp = message.mhIp;
    }
    if (message.mhNetmask !== "") {
      obj.mhNetmask = message.mhNetmask;
    }
    if (message.mhGateway !== "") {
      obj.mhGateway = message.mhGateway;
    }
    if (message.computerIp !== "") {
      obj.computerIp = message.computerIp;
    }
    if (message.computerNetmask !== "") {
      obj.computerNetmask = message.computerNetmask;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MicrohardLanSettingsPb>, I>>(base?: I): MicrohardLanSettingsPb {
    return MicrohardLanSettingsPb.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MicrohardLanSettingsPb>, I>>(object: I): MicrohardLanSettingsPb {
    const message = createBaseMicrohardLanSettingsPb();
    message.utime = object.utime ?? 0;
    message.mhIp = object.mhIp ?? "";
    message.mhNetmask = object.mhNetmask ?? "";
    message.mhGateway = object.mhGateway ?? "";
    message.computerIp = object.computerIp ?? "";
    message.computerNetmask = object.computerNetmask ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
